import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DateUtil} from '../../common/util/DateUtil';
import {Observable} from 'rxjs';
import {ClaimService} from './claim.service';
import {finalize, take, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SharedClmService {
  readonly dateFormat = DateUtil.dateFormat;

  constructor(
    public datePipe: DatePipe,
    private claimService: ClaimService,
  ) {
  }

  createDateRangeString(startDate, endDate): string {
    return `${this.datePipe.transform(startDate, this.dateFormat)} - ${this.datePipe.transform(endDate, this.dateFormat)} `;
  }

  public getConsultationVisitsBy(personId: number): Observable<{ visits: number, error?: any }> {
    return new Observable(observer => {
      this.claimService.getConsultationVisits(personId)
        .pipe(
          take(1),
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe({
          next: (visits: number) => {
            observer.next({visits});
          },
          error: (errorResponse) => {
            const error = errorResponse.error || 'Failed to fetch consultation visits per member';
            observer.error({visits: 0, error});
          }
        });
    });
  }

}
